import { Box, Button, ButtonAppearance, ButtonProps, ButtonSize } from '@bechtel/gds';
import { FC } from 'react';
import styled, { css } from 'styled-components';

export const ProjectAdminContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  height: 100vh;
`;

export const ProjectAdminHeaderStyled = styled(Box).attrs({ px: { sm: '500' }, pt: { sm: '600' }, pb: { sm: '550' } })`
  ${({ theme }) => css`
    background-image: linear-gradient(275deg, ${theme.colors.bechtel.blue[1000]}, ${theme.colors.bechtel.blue[800]});
  `}
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
  z-index: 1;
`;

export const ProjectAdminTabStyled = styled(Box).attrs({ pt: { sm: '600' }, pl: { sm: '400' } })`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}
export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  width: auto;
  min-width: 110px;
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;

export const ProjectAdminSubContainerStyled = styled(Box).attrs({
  mt: { sm: '400' },
  ml: { sm: '400' },
  mr: { sm: '300' },
})`
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[200]};
  overflow-y: auto;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  position: relative;
`;

export const FooterStyled = styled(Box).attrs({ p: { sm: '500' }, justifyContent: { sm: 'flex-end' } })`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding: ${theme.spacings[300]} ${theme.spacings[600]};
    white-space: nowrap;
  `}
`;
